/*
  telework.js
    telework module

*/
import * as types from '@/store/mutation-types'
import {
  sendTeleworkLog,
  getLatestTeleworkStatus,
  getTeleworkList,
  //getTeleworkingUserList,
  editTeleworkData,
  deleteTeleworkData,
  sendHolidayInfo,
  deleteHolidayInfo
} from '@/api'
import {
  TIME_DIFERENCE,
  LS_TOKEN_KEY,
  TeleworkCategory,
  HolidayCategory,
  getDayInMonth,
  getDayOfWeek,
  isNullorUndefined,
  formatDateMoment,
  getNowDatetimeMoment,
  calcHour,
  calcDiffTime
} from '@/common'
import { sLog } from '@/common/simple-logger'

export default {
  state: {
    sPrevTeleworkData: null,
    sTeleworkList: null,    // date, startTime, leaveTime, seatedTime, endTime
    sNextTeleworkData: null,
    sTeleworkingUserList: null,
    sWorkingHoursTotal: {working_days: 0, working_hours: '', leaving_hours: ''},
  },
  getters: {
    prevTeleworkData: state => state.sPrevTeleworkData,
    teleworkList: state => state.sTeleworkList,
    nextTeleworkData: state => state.sNextTeleworkData,
    teleworkingUserList: state => state.sTeleworkingUserList,
    workingHoursTotal: state => state.sWorkingHoursTotal
  },
  actions: {
    // -------------------------------------------------------------------------
    // Telework情報送信アクション
    async aSendTeleworkLog (context, payload) {
      sLog.debug('@action sendTeleworkLog ' + JSON.stringify(payload))

      const result = await sendTeleworkLog(
        payload.companyId,
        payload.userId,
        payload.teleworkLog,
        localStorage.getItem(LS_TOKEN_KEY)
      )
      if (result.error || result.body.error) {
        if (result.body.mismatch) {
          sLog.warn('telework state mismatch')
        }
        else {
          sLog.warn('failed update telework info')
        }
      }
      else if (!isNullorUndefined(payload.teleworkLog.list_row)) {
        // 勤務時間データ表に反映
        context.commit({
          type: types.INSERT_TELEWORK_LIST,
          data: payload.teleworkLog,
          id: result.body.workinghour_id
        })
      }
      return result
    },
    // -------------------------------------------------------------------------
    // 直近Telework情報取得アクション
    async aGetLatestTeleworkStatus (context, payload) {
      sLog.debug('@action getLatestTeleworkStatus ' + JSON.stringify(payload))

      const result = await getLatestTeleworkStatus(
        payload.companyId,
        payload.staffId,
        localStorage.getItem(LS_TOKEN_KEY)
      )
      if (result.error || result.body.error) {
        sLog.warn('failed update whereabouts info')
      }
      return result
    },
    // -------------------------------------------------------------------------
    // Telework情報一覧取得アクション
    async aGetTeleworkList (context, payload) {
      sLog.debug('@action getTeleworkList : ' + payload.companyId + ', ' + payload.memberId + ', ' + payload.date)
      const result = await getTeleworkList(
        payload.companyId,
        payload.memberId,
        payload.date,
        localStorage.getItem(LS_TOKEN_KEY)
      )

      if (!result.error && !result.body.error) {
        let telework_list = result.body.body

        context.commit({
          type: types.SET_TELEWORK_LIST,
          list: telework_list,
          date: payload.date
        })
      }

      return result
    },
    // -------------------------------------------------------------------------
    // Telework勤務中ユーザ一覧取得アクション
    /*async aGetTeleworkingUserList (context, payload) {
      sLog.debug('@action aGetTeleworkingUserList : ' + payload)
      const result = await getTeleworkingUserList(
        payload
      )

      if (!result.error && !result.body.error) {
        let tw_user_list = result.body.body
        context.commit(types.SET_TELEWORKING_USER_LIST, tw_user_list)
      }

      return result
    },
    // -------------------------------------------------------------------------
    // Telework勤務中ユーザ一覧に追加
    async aAddTeleworkingUserList (context, payload) {
      sLog.debug('@action aAddTeleworkingUserList : ' + payload)
      context.commit(types.ADD_TELEWORKING_USER_LIST, payload)
      return true
    },
    // -------------------------------------------------------------------------
    // Telework勤務中ユーザ一覧から削除
    async aDelTeleworkingUserList (context, payload) {
      sLog.debug('@action aDelTeleworkingUserList : ' + payload)
      context.commit(types.DEL_TELEWORKING_USER_LIST, payload)
      return true
    },*/
    // -------------------------------------------------------------------------
    // Telework情報更新アクション
    async aEditTeleworkData (context, payload) {
      sLog.debug('@action aEditTeleworkData ' + JSON.stringify(payload))

      const result = await editTeleworkData(
        payload,
        localStorage.getItem(LS_TOKEN_KEY)
      )
      if (result.error || result.body.error) {
        sLog.warn('failed edit telework')
      }
      else {
        // 更新データをTelework一覧に反映
        if (isNullorUndefined(payload.teleworkLog.workinghour_id)) {
          context.commit({
            type: types.INSERT_TELEWORK_LIST,
            data: payload.teleworkLog,
            id: result.body.workinghour_id
          })
        }
        else {
          context.commit(types.UPDATE_TELEWORK_LIST, payload.teleworkLog)
        }
      }

      return result
    },
    // -------------------------------------------------------------------------
    // Telework情報削除アクション
    async aDeleteTeleworkData (context, payload) {
      sLog.debug('@action deleteTeleworkData ' + JSON.stringify(payload))

      const result = await deleteTeleworkData(
        payload.teleworkLog.workinghour_id,
        localStorage.getItem(LS_TOKEN_KEY)
      )
      if (result.error || result.body.error) {
        sLog.warn('failed delete telework')
      }
      else {
        // 削除データをTelework一覧に反映
        payload.teleworkLog.time = ''
        payload.teleworkLog.comment = ''
        context.commit(types.DELETE_TELEWORK_LIST, payload.teleworkLog)
      }

      return result
    },
    // -------------------------------------------------------------------------
    // 休暇情報送信アクション
    async aSendHolidayInfo (context, payload) {
      sLog.debug('@action aSendHolidayInfo ' + JSON.stringify(payload))

      const result = await sendHolidayInfo(
        payload,
        localStorage.getItem(LS_TOKEN_KEY)
      )
      if (result.error || result.body.error) {
        sLog.warn('failed send holiday info')
      }
      else if (!isNullorUndefined(payload.list_row) && payload.list_row !== -1) {
        // 勤怠データ一覧反映先に位置の指定がある場合、更新データを一覧に反映
        let insWorkinghourId = null
        if (isNullorUndefined(payload.workinghour_id)) {
          insWorkinghourId = result.body.workinghour_id     // 登録時に作成したID
          sLog.debug('★  登録時に作成したID(' + insWorkinghourId + ')')
        }
        context.commit({
          type: types.UPDATE_HOLIDAY_INFO,
          data: payload,
          id: insWorkinghourId
        })
      }
      return result
    },
    // -------------------------------------------------------------------------
    // 休暇情報削除アクション
    async aDeleteHolidayInfo (context, payload) {
      sLog.debug('@action aDeleteHolidayInfo ' + JSON.stringify(payload))

      const result = await deleteHolidayInfo(
        payload.workinghour_id,
        localStorage.getItem(LS_TOKEN_KEY)
      )
      if (result.error || result.body.error) {
        sLog.warn('failed delete holiday')
      }
      else {
        // 削除データをTelework一覧に反映
        context.commit(types.DELETE_HOLIDAY_INFO, payload)
      }
      return result
    },
  },
  mutations: {
    // -------------------------------------------------------------------------
    // set telework list
    [types.SET_TELEWORK_LIST] (state, payload) {
      let result = convertTelewokListForDisp(payload.list, payload.date)
      state.sPrevTeleworkData = result.prev_data
      state.sTeleworkList = result.current_list
      state.sNextTeleworkData = result.next_data
      state.sWorkingHoursTotal = result.workinghours_total
    },
    // -------------------------------------------------------------------------
    // set teleworking user list
    /*[types.SET_TELEWORKING_USER_LIST] (state, twUserList) {
      let result = convertTeleworkingUserListToArray(twUserList)
      state.sTeleworkingUserList = result
    },
    // -------------------------------------------------------------------------
    // add staff_id to teleworking user list
    [types.ADD_TELEWORKING_USER_LIST] (state, staff_id) {
      if (state.sTeleworkingUserList.indexOf(staff_id) < 0) {
        // リストに存在しない場合は追加
        state.sTeleworkingUserList.push(staff_id)
      }
    },
    // -------------------------------------------------------------------------
    // del staff_id from teleworking user list
    [types.DEL_TELEWORKING_USER_LIST] (state, staff_id) {
      let pos = state.sTeleworkingUserList.indexOf(staff_id)
      if (pos >= 0) {
        // リストに存在する場合は削除
        state.sTeleworkingUserList.splice(pos, 1)
      }
    },*/
    // -------------------------------------------------------------------------
    // insert telework list
    [types.INSERT_TELEWORK_LIST] (state, payload) {
      let result = refInsertedTeleworkList(state.sTeleworkList, payload.data, payload.id)
      state.sTeleworkList = result.telework_list
      state.sWorkingHoursTotal = result.workinghours_total
    },
    // -------------------------------------------------------------------------
    // update telework list
    [types.UPDATE_TELEWORK_LIST] (state, ref_data) {
      let result = refUpdatedTeleworkList(state.sTeleworkList, ref_data)
      state.sTeleworkList = result.telework_list
      state.sWorkingHoursTotal = result.workinghours_total
    },
    // -------------------------------------------------------------------------
    // delete telework list
    [types.DELETE_TELEWORK_LIST] (state, ref_data) {
      let result = refDeletedTeleworkList(state.sTeleworkList, ref_data)
      state.sTeleworkList = result.telework_list
      state.sWorkingHoursTotal = result.workinghours_total
    },
    // -------------------------------------------------------------------------
    // insert/update holiday to telework list
    [types.UPDATE_HOLIDAY_INFO] (state, payload) {
      let result = refUpdateHolidayInfoToTeleworkList(state.sTeleworkList, state.sWorkingHoursTotal, payload.data, payload.id)
      if (result !== null) {
        state.sTeleworkList = result.telework_list
        state.sWorkingHoursTotal = result.workinghours_total
      }
    },
    // -------------------------------------------------------------------------
    // delete holiday to telework list
    [types.DELETE_HOLIDAY_INFO] (state, ref_data) {
      let result = refDeleteHolidayInfoToTeleworkList(state.sTeleworkList, state.sWorkingHoursTotal, ref_data)
      if (result !== null) {
        state.sTeleworkList = result.telework_list
        state.sWorkingHoursTotal = result.workinghours_total
      }
    },
  },
}

// テレワークリスト表示用にデータを変換
export function convertTelewokListForDisp (list, date) {
  //sLog.debug('★[convertTelewokListForDisp] ' + JSON.stringify(list))
  if (isNullorUndefined(list)) {
    return {
      current_list: [],
      next_data: null
    }
  }

  const weekDayList = [ '(日)', '(月)', '(火)', '(水)', '(木)', '(金)', '(土)' ]
  let index = 0
  let day_count = 1
  let row_count = 0
  let samedate_flg = false
  let current_date = ''
  let dayInMonth = getDayInMonth(date)
  let retTeleworkList = []
  let retPrevTeleworkData = null
  let retNextTeleworkData = null
  let start_pos = 0
  let end_pos = -1
  if (list.length !== 0) {
    // 日時チェック用データ取得
    if (list[0].linked_date.slice(0, 6) < date) {
      // リストの先頭のliked_dateが現在年月より過去の場合、前月以前の最後のデータとして取得
      retPrevTeleworkData = list[0]
      list.shift()
      //sLog.debug('★  → 前月以前の最後のデータ取得[' + JSON.stringify(retPrevTeleworkData) + ']')
    }
    if (list.length !== 0) {
      if (list[list.length - 1].linked_date.slice(0, 6) > date) {
        // リストの末尾のliked_dateが現在年月より未来の場合、翌月以降の最初のデータとして取得
        retNextTeleworkData = list[list.length - 1]
        //sLog.debug('★  → 翌月以降の最初のデータ取得[' + JSON.stringify(retNextTeleworkData) + ']')
      }
    }
  }

  // (1)ループ
  while (day_count <= dayInMonth) {
    //sLog.debug('★(1)ループカウンタ [' + day_count + '/' + dayInMonth + ']')
    if (samedate_flg === false) {
      // 前の行と別の日付
      // 新しい日付を作成
      current_date = date + ('00' + day_count).slice(-2)
      //sLog.debug('★  →前行と別日(' + current_date + ')')
    }
    row_count++
    let telework_data = {
      list_row: row_count,
      date: current_date.slice(0, 4) + '-' + current_date.slice(4, 6) + '-' + current_date.slice(6),        // YYYY-MM-DD形式
      dispDate: samedate_flg === false ? Number(current_date.slice(-2)) + weekDayList[getDayOfWeek(current_date)] : '',
      startId: null,
      startTime: '',
      startComment: '',
      startUpdateDate: '',
      leaveId: null,
      leaveTime: '',
      leaveComment: '',
      leaveUpdateDate: '',
      seatedId: null,
      seatedTime: '',
      seatedComment: '',
      seatedUpdateDate: '',
      endId: null,
      endTime: '',
      endComment: '',
      endUpdateDate: '',
      holidayId: null,
      holidayCategory: 0,
      holidayComment: '',
      holidayUpdateDate: '',
      working_hours: '',
      leaving_hours: ''
    }

    if (index >= list.length ||
        list[index].linked_date !== current_date) {
      // リストにデータが残っていない、
      // または登録した日付が処理中の日付と異なる場合は、空行を作成
      //sLog.debug('★  → 空行')
      retTeleworkList.push(telework_data)
      day_count++
      continue
    }

    // (2)テレワークデータループ
    //sLog.debug('★    linked_date：' + list[index].linked_date)
    samedate_flg = false
    let first_index = index
    for (let i = index; i < list.length; i++) {
      //sLog.debug('★    (2) [' + i + '/' + list.length + '] 種別：' + list[i].category + '、日時：' + list[i].input_date + list[i].input_hour)
      if (list[i].linked_date !== current_date) {
        // 登録した日付が処理中の日付と異なる場合は、次の日付のデータ処理へ
        //sLog.debug('★      → 処理中の日付と異なるため次のデータへ')
        break
      }
      if (i !== 0 &&
          i !== first_index &&
          list[i].category <= list[i - 1].category) {
        // 処理中データの種別が、１つ前の種別よりも小さい値の場合は、同一日の次の行に表示する
        //sLog.debug('★      → 同一日で次の行')
        samedate_flg = true
        break
      }

      let cross_date = ''
      if (list[i].input_date !== '00000000' &&      // '00000000'→休暇情報の場合の設定値
          list[i].linked_date !== list[i].input_date) {
        // 登録した日付と入力した日付が異なる場合は日またがり(表示用のYYYY/MM/DDを作成)
        if (list[i].linked_date.slice(0, 4) !== list[i].input_date.slice(0, 4)) {
          // 年部分が異なる場合
          cross_date += list[i].input_date.slice(0, 4) + '/'
        }
        cross_date += list[i].input_date.slice(4, 6) + '/' + list[i].input_date.slice(6, 8) + ' '
        //sLog.debug('★      → 日またがり')
      }

      // １行分データに設定
      switch (list[i].category) {
        case TeleworkCategory.START:
          // 勤務開始
          /*if (telework_data.startId !== null) {
            // 設定済みの場合は同一日付で別の行データとする
            //sLog.debug('★      → (勤務開始)別行へ')
            samedate_flg = true
            break
          }*/
          telework_data.startId = list[i].workinghour_id
          telework_data.startTime = list[i].input_hour.slice(0, 2) + ':' + list[i].input_hour.slice(2, 4)   // 日またぎなし
          telework_data.startComment = list[i].message
          if (list[i].updated === 1) {
            let tmp_udate = calcHour(list[i].update_date, TIME_DIFERENCE)
            telework_data.startUpdateDate = formatDateMoment(tmp_udate, 'YYYY-MM-DD HH:mm')
          }
          end_pos = row_count - 1
          break
        case TeleworkCategory.LEAVE:
          // 離席
          /*if (telework_data.leaveId !== null) {
            // 設定済みの場合は同一日付で別の行データとする
            //sLog.debug('★      → (離席)別行へ')
            samedate_flg = true
            break
          }*/
          telework_data.leaveId = list[i].workinghour_id
          telework_data.leaveTime = cross_date + list[i].input_hour.slice(0, 2) + ':' + list[i].input_hour.slice(2, 4)
          telework_data.leaveComment = list[i].message
          if (list[i].updated === 1) {
            let tmp_udate = calcHour(list[i].update_date, TIME_DIFERENCE)
            telework_data.leaveUpdateDate = formatDateMoment(tmp_udate, 'YYYY-MM-DD HH:mm')
          }
          end_pos = row_count - 1
          break
        case TeleworkCategory.SEATED:
          // 着席
          /*if (telework_data.seatedId !== null) {
            // 設定済みの場合は同一日付で別の行データとする
            //sLog.debug('★      → (着席))別行へ')
            samedate_flg = true
            break
          }*/
          telework_data.seatedId = list[i].workinghour_id
          telework_data.seatedTime = cross_date + list[i].input_hour.slice(0, 2) + ':' + list[i].input_hour.slice(2, 4)
          telework_data.seatedComment = list[i].message
          if (list[i].updated === 1) {
            let tmp_udate = calcHour(list[i].update_date, TIME_DIFERENCE)
            telework_data.seatedUpdateDate = formatDateMoment(tmp_udate, 'YYYY-MM-DD HH:mm')
          }
          end_pos = row_count - 1
          break
        case TeleworkCategory.END:
          // 勤務終了
          /*if (telework_data.endId !== null) {
            // 設定済みの場合は同一日付で別の行データとする
            //sLog.debug('★      → (勤務終了)別行へ')
            samedate_flg = true
            break
          }*/
          telework_data.endId = list[i].workinghour_id
          telework_data.endTime = cross_date + list[i].input_hour.slice(0, 2) + ':' + list[i].input_hour.slice(2, 4)
          telework_data.endComment = list[i].message
          if (list[i].updated === 1) {
            let tmp_udate = calcHour(list[i].update_date, TIME_DIFERENCE)
            telework_data.endUpdateDate = formatDateMoment(tmp_udate, 'YYYY-MM-DD HH:mm')
          }
          end_pos = row_count - 1
          break
        case HolidayCategory.PAID:
        case HolidayCategory.SPECIAL:
        case HolidayCategory.SUBSTITUTE:
        case HolidayCategory.ABSENCE:
          // 休暇
          telework_data.holidayId = list[i].workinghour_id
          telework_data.holidayCategory = list[i].category
          telework_data.holidayComment = list[i].message
          if (list[i].updated === 1) {
            let tmp_udate = calcHour(list[i].update_date, TIME_DIFERENCE)
            telework_data.holidayUpdateDate = formatDateMoment(tmp_udate, 'YYYY-MM-DD HH:mm')
          }
          end_pos = -1      // 休暇データが存在する日は、勤務時間の計算を行う必要が無いため、end_posを設定しない

          for (let j = (i + 1); j < list.length; j++) {
            // 同日のデータが存在する場合は無視
            if (list[j].linked_date !== current_date) {
              break
            }
            i++
            index++
          }
          break
        default:
          break
      }
      /*if (samedate_flg === true) {
        break
      }*/
      index++
      //sLog.debug('★      → 次のデータへ(indexインクリメント：' + index + ')')
    } // end of for (2)

    // 作成した１行分データを返却リストにpush
    retTeleworkList.push(telework_data)

    if (samedate_flg === false) {
      // １日分のデータ作成完了

      // 同日データの勤務時間を算出
      //sLog.debug('★勤務時間算出★ start(' + start_pos + ') end(' + end_pos + ')')
      retTeleworkList = calcWorkingHour(retTeleworkList, start_pos, end_pos)
      start_pos = row_count
      end_pos = -1

      day_count++
    }
    //sLog.debug('★      → 次の行データへ(day_count：' + day_count + ')')
  } // end of while (1)

  // 勤務時間、離席時間の合計値を取得
  let workingHoursTotal = calcWorkingHoursTotal(retTeleworkList)

  //sLog.debug('★前月以前データ： ' + JSON.stringify(retPrevTeleworkData))
  //sLog.debug('★テレワークデータ整形後： ' + JSON.stringify(retTeleworkList))
  //sLog.debug('★翌月以降データ： ' + JSON.stringify(retNextTeleworkData))

  return {
    prev_data: retPrevTeleworkData,
    current_list: retTeleworkList,
    next_data: retNextTeleworkData,
    workinghours_total: workingHoursTotal
  }
}

/*export function convertTeleworkingUserListToArray (twUserList) {
  let retArray = []
  twUserList.forEach(function (userInfo) {
    retArray.push(userInfo.staff_id)
  })
  return retArray
}*/

// テレワークリストに登録したデータを反映
// [IN] telework_list ：反映先
//      ref_data      ：登録したテレワークデータ
//      workinghour_id：登録したid
export function refInsertedTeleworkList (telework_list, ref_data, workinghour_id) {
  let retTeleworkList = telework_list
  const datetimeStr = formatDateMoment(getNowDatetimeMoment(), 'YYYY-MM-DD HH:mm')

  // 表示中の一覧データに、登録したデータを追加する
  const pos = ref_data.list_row - 1
  switch (ref_data.category) {
    case TeleworkCategory.START:
      // 勤務開始
      retTeleworkList[pos].startId = workinghour_id
      retTeleworkList[pos].startTime = createRefTime(retTeleworkList[pos].date, ref_data.date, ref_data.time)
      retTeleworkList[pos].startComment = ref_data.comment
      retTeleworkList[pos].startUpdateDate = datetimeStr
      break
    case TeleworkCategory.LEAVE:
      // 離席
      retTeleworkList[pos].leaveId = workinghour_id
      retTeleworkList[pos].leaveTime = createRefTime(retTeleworkList[pos].date, ref_data.date, ref_data.time)
      retTeleworkList[pos].leaveComment = ref_data.comment
      retTeleworkList[pos].leaveUpdateDate = datetimeStr
      break
    case TeleworkCategory.SEATED:
      // 着席
      retTeleworkList[pos].seatedId = workinghour_id
      retTeleworkList[pos].seatedTime = createRefTime(retTeleworkList[pos].date, ref_data.date, ref_data.time)
      retTeleworkList[pos].seatedComment = ref_data.comment
      retTeleworkList[pos].seatedUpdateDate = datetimeStr
      break
    case TeleworkCategory.END:
      // 勤務終了
      retTeleworkList[pos].endId = workinghour_id
      retTeleworkList[pos].endTime = createRefTime(retTeleworkList[pos].date, ref_data.date, ref_data.time)
      retTeleworkList[pos].endComment = ref_data.comment
      retTeleworkList[pos].endUpdateDate = datetimeStr
      break
    default:
      break
  }

  // 勤務時間再計算のため、同日データ範囲を検索
  let start_pos = -1
  for (start_pos = pos; start_pos >= 0; start_pos--) {
    // 同日データの最初の行を検出する
    if (retTeleworkList[start_pos].date !== retTeleworkList[pos].date) {
      break
    }
  }
  start_pos++
  let end_pos = -1
  for (end_pos = pos; end_pos < retTeleworkList.length; end_pos++) {
    // 同日データの最後の行を検出する
    if (retTeleworkList[end_pos].date !== retTeleworkList[pos].date) {
      break
    }
  }
  end_pos--
  retTeleworkList = calcWorkingHour(retTeleworkList, start_pos, end_pos)

  // 勤務時間、離席時間の合計値を取得
  let workingHoursTotal = calcWorkingHoursTotal(retTeleworkList)

  return {
    telework_list: retTeleworkList,
    workinghours_total: workingHoursTotal
  }
}

// テレワークリストに更新したデータを反映
export function refUpdatedTeleworkList (telework_list, ref_data) {
  let retTeleworkList = telework_list
  const datetimeStr = formatDateMoment(getNowDatetimeMoment(), 'YYYY-MM-DD HH:mm')

  // 表示中の一覧データに、更新したデータを反映する
  const pos = ref_data.list_row - 1
  switch (ref_data.category) {
    case TeleworkCategory.START:
      // 勤務開始
      if (retTeleworkList[pos].startId === ref_data.workinghour_id) {
        retTeleworkList[pos].startTime = createRefTime(retTeleworkList[pos].date, ref_data.date, ref_data.time)
        retTeleworkList[pos].startComment = ref_data.comment
        retTeleworkList[pos].startUpdateDate = datetimeStr
      }
      break
    case TeleworkCategory.LEAVE:
      // 離席
      if (retTeleworkList[pos].leaveId === ref_data.workinghour_id) {
        retTeleworkList[pos].leaveTime = createRefTime(retTeleworkList[pos].date, ref_data.date, ref_data.time)
        retTeleworkList[pos].leaveComment = ref_data.comment
        retTeleworkList[pos].leaveUpdateDate = datetimeStr
      }
      break
    case TeleworkCategory.SEATED:
      // 着席
      if (retTeleworkList[pos].seatedId === ref_data.workinghour_id) {
        retTeleworkList[pos].seatedTime = createRefTime(retTeleworkList[pos].date, ref_data.date, ref_data.time)
        retTeleworkList[pos].seatedComment = ref_data.comment
        retTeleworkList[pos].seatedUpdateDate = datetimeStr
      }
      break
    case TeleworkCategory.END:
      // 勤務終了
      if (retTeleworkList[pos].endId === ref_data.workinghour_id) {
        retTeleworkList[pos].endTime = createRefTime(retTeleworkList[pos].date, ref_data.date, ref_data.time)
        retTeleworkList[pos].endComment = ref_data.comment
        retTeleworkList[pos].endUpdateDate = datetimeStr
      }
      break
    default:
      break
  }

  // 勤務時間再計算のため、同日データ範囲を検索
  let start_pos = -1
  for (start_pos = pos; start_pos >= 0; start_pos--) {
    // 同日データの最初の行を検出する
    if (retTeleworkList[start_pos].date !== retTeleworkList[pos].date) {
      break
    }
  }
  start_pos++
  let end_pos = -1
  for (end_pos = pos; end_pos < retTeleworkList.length; end_pos++) {
    // 同日データの最後の行を検出する
    if (retTeleworkList[end_pos].date !== retTeleworkList[pos].date) {
      break
    }
  }
  end_pos--
  retTeleworkList = calcWorkingHour(retTeleworkList, start_pos, end_pos)

  // 勤務時間、離席時間の合計値を取得
  let workingHoursTotal = calcWorkingHoursTotal(retTeleworkList)

  return {
    telework_list: retTeleworkList,
    workinghours_total: workingHoursTotal
  }
}

// テレワークリストから該当の勤務時間データをクリア
export function refDeletedTeleworkList (telework_list, ref_data) {
  let retTeleworkList = telework_list

  // 表示中の一覧データに、削除したデータを反映する
  const pos = ref_data.list_row - 1
  switch (ref_data.category) {
    case TeleworkCategory.START:
      // 勤務開始
      if (retTeleworkList[pos].startId === ref_data.workinghour_id) {
        retTeleworkList[pos].startId = null
        retTeleworkList[pos].startTime = ''
        retTeleworkList[pos].startComment = ''
        retTeleworkList[pos].startUpdateDate = ''
      }
      break
    case TeleworkCategory.LEAVE:
      // 離席
      if (retTeleworkList[pos].leaveId === ref_data.workinghour_id) {
        retTeleworkList[pos].leaveId = null
        retTeleworkList[pos].leaveTime = ''
        retTeleworkList[pos].leaveComment = ''
        retTeleworkList[pos].leaveUpdateDate = ''
      }
      break
    case TeleworkCategory.SEATED:
      // 着席
      if (retTeleworkList[pos].seatedId === ref_data.workinghour_id) {
        retTeleworkList[pos].seatedId = null
        retTeleworkList[pos].seatedTime = ''
        retTeleworkList[pos].seatedComment = ''
        retTeleworkList[pos].seatedUpdateDate = ''
      }
      break
    case TeleworkCategory.END:
      // 勤務終了
      if (retTeleworkList[pos].endId === ref_data.workinghour_id) {
        retTeleworkList[pos].endId = null
        retTeleworkList[pos].endTime = ''
        retTeleworkList[pos].endComment = ''
        retTeleworkList[pos].endUpdateDate = ''
      }
      break
    default:
      break
  }
  // 勤務時間再計算のため、同日データ範囲を検索
  let start_pos = -1
  for (start_pos = pos; start_pos >= 0; start_pos--) {
    // 同日データの最初の行を検出する
    if (retTeleworkList[start_pos].date !== retTeleworkList[pos].date) {
      break
    }
  }
  start_pos++
  let end_pos = -1
  for (end_pos = pos; end_pos < retTeleworkList.length; end_pos++) {
    // 同日データの最後の行を検出する
    if (retTeleworkList[end_pos].date !== retTeleworkList[pos].date) {
      break
    }
  }
  end_pos--
  retTeleworkList = calcWorkingHour(retTeleworkList, start_pos, end_pos)

  // 勤務時間、離席時間の合計値を取得
  let workingHoursTotal = calcWorkingHoursTotal(retTeleworkList)

  return {
    telework_list: retTeleworkList,
    workinghours_total: workingHoursTotal
  }
}

// テレワークリストに登録/更新した休暇情報を反映
// [IN] telework_list     ：反映先
//      workingHoursTotal : 勤務時間合計
//      ref_data          ：登録したテレワークデータ
//      workinghour_id    ：登録したid(更新の場合はnull)
export function refUpdateHolidayInfoToTeleworkList (telework_list, workingHoursTotal, ref_data, workinghour_id) {
  //sLog.debug('★[refUpdateHolidayInfoToTeleworkList] ID(' + workinghour_id + ') data(' + JSON.stringify(ref_data) + ')')
  let retTeleworkList = telework_list
  const datetimeStr = formatDateMoment(getNowDatetimeMoment(), 'YYYY-MM-DD HH:mm')

  // 表示中の一覧データに、登録したデータを追加する
  const pos = ref_data.list_row - 1
  if (workinghour_id === null) {
    // 登録時に作成したIDがnull = 更新
    //sLog.debug('★  更新')
    if (retTeleworkList[pos].holidayId !== ref_data.workinghour_id) {
      // IDが一致しない場合は一覧データに反映しない
      //sLog.debug('★  →反映しない')
      return null
    }
  }
  else {
    //sLog.debug('★  追加(変更前休暇日数:' + workingHoursTotal.holiday_days + ')')
    // 休暇情報追加の場合
    retTeleworkList[pos].holidayId = workinghour_id
    workingHoursTotal.holiday_days = workingHoursTotal.holiday_days + 1   // 休暇日数を加算
    //sLog.debug('★  → 休暇日数更新(' + workingHoursTotal.holiday_days + ')')
  }
  retTeleworkList[pos].holidayCategory = ref_data.category
  retTeleworkList[pos].holidayComment = ref_data.comment
  retTeleworkList[pos].holidayUpdateDate = datetimeStr
  //sLog.debug('★  更新後(' + JSON.stringify(retTeleworkList) + ')')

  return {
    telework_list: retTeleworkList,
    workinghours_total: workingHoursTotal
  }
}

// テレワークリストから該当の休暇情報をクリア
// [IN] telework_list     ：反映先
//      workingHoursTotal : 勤務時間合計
//      ref_data          ：登録したテレワークデータ
export function refDeleteHolidayInfoToTeleworkList (telework_list, workingHoursTotal, ref_data) {
  //sLog.debug('★[refDeleteHolidayInfoToTeleworkList] data(' + JSON.stringify(ref_data) + ')')
  let retTeleworkList = telework_list
  if (isNullorUndefined(ref_data.list_row) || ref_data.list_row === -1) {
    // 反映位置の指定なし
    return null
  }

  // 表示中の一覧データに、削除したデータを反映する
  const pos = ref_data.list_row - 1
  if (retTeleworkList[pos].holidayId === ref_data.workinghour_id) {
    //sLog.debug('★  削除(削除前休暇日数:' + workingHoursTotal.holiday_days + ')')
    retTeleworkList[pos].holidayId = null
    retTeleworkList[pos].holidayCategory = 0
    retTeleworkList[pos].holidayComment = ''
    retTeleworkList[pos].holidayUpdateDate = ''

    workingHoursTotal.holiday_days = workingHoursTotal.holiday_days - 1   // 休暇日数を減算
    //sLog.debug('★  → 休暇日数更新(' + workingHoursTotal.holiday_days + ')')
  }
  //sLog.debug('★  →削除後(' + JSON.stringify(retTeleworkList) + ')')

  return {
    telework_list: retTeleworkList,
    workinghours_total: workingHoursTotal
  }
}

// 同日データの勤務時間、離席時間を計算する
// [IN]  teleworkList ：編集対象の勤務時間データリスト
//       start_pos    ：同日データの先頭位置
//       end_pos      ：同日データの末尾位置
// [OUT] 勤務時間を再計算した勤務時間データリスト
export function calcWorkingHour (teleworkList, start_pos, end_pos) {
  if (start_pos === -1 || end_pos === -1) {
    return teleworkList
  }

  let working_hours = 0
  let leaving_hours = 0
  let start_datetime = ''
  let leave_datetime = ''
  let seated_datetime = ''
  let end_datetime = ''
  let start_flg = 0
  for (let i = 0; i <= (end_pos - start_pos); i++) {
    let data = teleworkList[start_pos + i]
    if (data.startTime !== '') {
      start_flg = 1
      start_datetime = data.date.replace(/-/g, '') + data.startTime.replace(/:/g, '')
      leave_datetime = ''
      seated_datetime = ''
      end_datetime = ''
    }
    if (data.leaveTime !== '') {
      let tmp_date = data.leaveTime.replace(/ /g, '').replace(/\//g, '').replace(/:/g, '')   // 年月日またぎの場合の「 」「/」「:」を削除
      leave_datetime = data.date.replace(/-/g, '').slice(0, (12 - tmp_date.length)) + tmp_date
      seated_datetime = ''
    }
    if (data.seatedTime !== '') {
      let tmp_date = data.seatedTime.replace(/ /g, '').replace(/\//g, '').replace(/:/g, '')   // 年月日またぎの場合の「 」「/」「:」を削除
      seated_datetime = data.date.replace(/-/g, '').slice(0, (12 - tmp_date.length)) + tmp_date
      if (start_flg === 1 && leave_datetime !== '') {
        let diff_time = calcDiffTime(leave_datetime, seated_datetime, 'YYYYMMDDhhmm')
        leaving_hours += diff_time
        leave_datetime = ''
        seated_datetime = ''
      }
    }
    if (data.endTime !== '') {
      let tmp_date = data.endTime.replace(/ /g, '').replace(/\//g, '').replace(/:/g, '')   // 年月日またぎの場合の「 」「/」「:」を削除
      end_datetime = data.date.replace(/-/g, '').slice(0, (12 - tmp_date.length)) + tmp_date
      if (start_datetime !== '') {
        let diff_time = calcDiffTime(start_datetime, end_datetime, 'YYYYMMDDhhmm')
        working_hours += diff_time
        if (leave_datetime !== '' && seated_datetime === '') {
          // 着席の勤務データなしで勤務終了した場合は、離席～勤務終了を離席時間をして計上する
          let diff_time = calcDiffTime(leave_datetime, end_datetime, 'YYYYMMDDhhmm')
          leaving_hours += diff_time
          leave_datetime = ''
        }
        start_datetime = ''
        end_datetime = ''
      }
    }
  } // end-of-for

  if (working_hours !== 0) {
    working_hours = working_hours - leaving_hours    // 離席時間を減算
    if (working_hours < 6000) {
      teleworkList[end_pos].working_hours = ('00' + (Math.floor(working_hours / 60)).toString()).slice(-2) + ':' + ('00' + (working_hours % 60).toString()).slice(-2)
    }
    else {
      teleworkList[end_pos].working_hours = (Math.floor(working_hours / 60)).toString() + ':' + ('00' + (working_hours % 60).toString()).slice(-2)
    }
  }
  else {
    teleworkList[end_pos].working_hours = ''
  }

  if (working_hours !== 0 && leaving_hours !== 0) {
    if (leaving_hours < 6000) {
      teleworkList[end_pos].leaving_hours = ('00' + (Math.floor(leaving_hours / 60)).toString()).slice(-2) + ':' + ('00' + (leaving_hours % 60).toString()).slice(-2)
    }
    else {
      teleworkList[end_pos].leaving_hours = (Math.floor(leaving_hours / 60)).toString() + ':' + ('00' + (leaving_hours % 60).toString()).slice(-2)
    }
  }
  else {
    teleworkList[end_pos].leaving_hours = ''
  }
  //sLog.debug('★勤務時間計算結果：' + JSON.stringify(teleworkList[end_pos]))
  return teleworkList
}

// 勤務時間、離席時間の合計を算出する
// [IN]  teleworkList ：勤務時間データリスト
// [OUT] 勤務時間合計(working_days：勤務日数、holiday_days：休暇日数、working_hours：勤務時間、leaving_hours：離席時間)
export function calcWorkingHoursTotal (teleworkList) {
  let workingHoursTotal = {
    working_days: 0,
    holiday_days: 0,
    working_hours: '',
    leaving_hours: ''
  }
  if (isNullorUndefined(teleworkList)) {
    return workingHoursTotal
  }

  let w_days = 0
  let h_days = 0
  let wh_total = 0
  let lh_total = 0
  for (let i = 0; i < teleworkList.length; i++) {
    if (teleworkList[i].holidayCategory >= HolidayCategory.PAID) {
      h_days++
      continue
    }

    let wh_num = 0
    let lh_num = 0
    let wh_str = teleworkList[i].working_hours
    let lh_str = teleworkList[i].leaving_hours
    if (wh_str !== '' || lh_str !== '') {
      w_days++
      if (wh_str !== '') {
        wh_num = (Number(wh_str.split(':')[0]) * 60) + Number(wh_str.split(':')[1])
      }
      if (lh_str !== '') {
        lh_num = (Number(lh_str.split(':')[0]) * 60) + Number(lh_str.split(':')[1])
      }
      wh_total += wh_num
      lh_total += lh_num
    }
  }
  workingHoursTotal.working_days = w_days
  let wh_total_str = ''
  let lh_total_str = ''
  if (wh_total < 6000) {
    wh_total_str = ('00' + (Math.floor(wh_total / 60)).toString()).slice(-2) + ':' + ('00' + (wh_total % 60).toString()).slice(-2)
  }
  else {
    wh_total_str = (Math.floor(wh_total / 60)).toString() + ':' + ('00' + (wh_total % 60).toString()).slice(-2)
  }
  if (lh_total < 6000) {
    lh_total_str = ('00' + (Math.floor(lh_total / 60)).toString()).slice(-2) + ':' + ('00' + (lh_total % 60).toString()).slice(-2)
  }
  else {
    lh_total_str = (Math.floor(lh_total / 60)).toString() + ':' + ('00' + (lh_total % 60).toString()).slice(-2)
  }

  workingHoursTotal = {
    working_days: w_days,
    holiday_days: h_days,
    working_hours: wh_total_str,
    leaving_hours: lh_total_str
  }
  //sLog.debug('★結果：' + JSON.stringify(workingHoursTotal))
  return workingHoursTotal
}

// 表示用の時間を作成
// [IN]  prev_date：行日付(YYYY-MM-DD)
//       ref_date ：変更後の日付(YYYY-MM-DD)
//       time     ：変更後の時間(hh:mm)
// [OUT] 日またぎなし→hh:mm、日またぎあり→YYYY/MM/DD hh:mm
export function createRefTime (prev_date, ref_date, time) {
  if (prev_date !== ref_date) {
    // 日付が不一致(日またぎ)の場合
    let ret_datetime = ''
    if (prev_date.slice(0, 4) !== ref_date.slice(0, 4)) {
      ret_datetime = ref_date.slice(0, 4) + '/'   // 年またぎ
    }
    ret_datetime += ref_date.slice(5, 7) + '/' + ref_date.slice(-2) + ' ' + time
    return ret_datetime
  }
  return time
}



// WEBPACK FOOTER //
// ./src/store/modules/telework.js